import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router";
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const ConfigListing: React.FC = () => {
  const navigate = useNavigate();

  // Static configuration list
  const configurations = [
    { id: "header", name: "Header Configuration", editPath: "/web-builder/edit-header" },
    { id: "footer", name: "Footer Configuration", editPath: "/web-builder/edit-footer" },
  ];

  return (
    <div>
      <Helmet>
        <title>Configuration Management</title>
      </Helmet>

      <h2>Configuration Management</h2>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Configuration Name</strong></TableCell>
              <TableCell align="right"><strong>Actions</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {configurations.map((config) => (
              <TableRow key={config.id}>
                <TableCell>{config.name}</TableCell>
                <TableCell align="right">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate(config.editPath)}
                    startIcon={<EditIcon />}
                  >
                    Edit
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ConfigListing;
